/**
 * AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
 *
 * This file is generated by the theme generator.
 * To modify typography tokens, edit: scripts/theme-generator/config.ts
 * Then run: pnpm generate:themes
 */

/**
 * Atoms typography utility names — the `{family}-{size}` part of each
 * `text-*` utility (e.g. `text-display-lg`). Source of truth:
 * `THEME_CONFIG.typography` in scripts/theme-generator/config.ts.
 */
export const ATOMS_TYPOGRAPHY_CLASSES = [
  'display-lg',
  'display-md',
  'display-sm',
  'display-xs',
  'header-lg',
  'header-md',
  'header-sm',
  'subheader-lg',
  'subheader-md',
  'subheader-sm',
  'subheader-xs',
  'body-xl',
  'body-lg',
  'body-md',
  'body-sm',
  'label-xl',
  'label-lg',
  'label-md',
  'label-sm',
] as const;

export type AtomsTypographyClass = (typeof ATOMS_TYPOGRAPHY_CLASSES)[number];
